'use client'

import React from 'react'
import Carousel from 'react-material-ui-carousel'
import Paper from '@mui/material/Paper'
import Image from 'next/image'
import { ARTICLES_BASE_IMG_URL } from '@/constants/AppConfig'

interface CarouselItemProps {
  imgSrc: string
  alt: string
  isPriority?: boolean
}

function CarouselItem({ imgSrc, alt, isPriority = false }: CarouselItemProps) {
  return (
    <Paper
      elevation={3}
      sx={{
        height: { xs: '200px', sm: '300px', md: '400px' },
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'rgba(0,0,0,0.04)', // Light background while loading
      }}
    >
      <Image
        src={`${ARTICLES_BASE_IMG_URL}/${imgSrc}`}
        alt={alt}
        fill
        sizes="(max-width: 600px) 100vw, (max-width: 1200px) 80vw, 800px"
        priority={isPriority}
        loading={isPriority ? 'eager' : 'lazy'}
        placeholder="blur"
        blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIj48c3RvcCBzdG9wLWNvbG9yPSIjZjVmNWY1IiBvZmZzZXQ9IjIwJSIgLz48c3RvcCBzdG9wLWNvbG9yPSIjZWVlIiBvZmZzZXQ9IjUwJSIgLz48c3RvcCBzdG9wLWNvbG9yPSIjZjVmNWY1IiBvZmZzZXQ9IjcwJSIgLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cmVjdCB3aWR0aD0iODAiIGhlaWdodD0iNDAiIGZpbGw9IiNmNWY1ZjUiLz48cmVjdCBpZD0iciIgd2lkdGg9IjgwIiBoZWlnaHQ9IjQwIiBmaWxsPSJ1cmwoI2cpIi8+PGFuaW1hdGUgeGxpbms6aHJlZj0iI3IiIGF0dHJpYnV0ZU5hbWU9IngiIGZyb209Ii04MCIgdG89IjgwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+PC9zdmc+"
        style={{ objectFit: 'cover' }}
      />
    </Paper>
  )
}

interface ClientCarouselProps {
  images: string[]
  alt: string
}

const ClientCarousel: React.FC<ClientCarouselProps> = ({ images, alt }) => {
  return (
    <Carousel animation="slide" navButtonsAlwaysVisible={true} swipe={true} indicators={true} interval={6000}>
      {images.map((imgSrc: string, index: number) => (
        <CarouselItem
          key={index}
          imgSrc={imgSrc}
          alt={alt}
          isPriority={index === 0} // Only prioritize the first image
        />
      ))}
    </Carousel>
  )
}

export default ClientCarousel
